import { z } from 'zod/v4';

import type { InfinexMessageNamespace } from './base';
import { generateEventSchema } from './schemaBuilder';

import { storedDataSchema } from '../storage';

/* ──────────────── Constants ──────────────── */
export const StoredDataMethods = [
  'storage-write',
  'storage-read',
  'storage-reset',
] as const;

export type StoredDataMethod = (typeof StoredDataMethods)[number];

const namespace: InfinexMessageNamespace = 'stored-data';

/* ──────────────── storage-write ──────────────── */
export const requestStorageWriteSchema = generateEventSchema({
  namespace,
  method: 'storage-write',
  requestData: storedDataSchema,
  responseData: z.boolean(),
  notificationData: z.never(),
});

/* ──────────────── storage-read ──────────────── */
export const requestStorageReadSchema = generateEventSchema({
  namespace,
  method: 'storage-read',
  requestData: z.null(),
  responseData: storedDataSchema,
  notificationData: z.never(),
});

/* ──────────────── storage-reset ──────────────── */
export const requestStorageResetSchema = generateEventSchema({
  namespace,
  method: 'storage-reset',
  requestData: z.null(),
  responseData: z.boolean(),
  notificationData: z.never(),
});

/* ──────────────── Aggregated schema arrays ──────────────── */
export const storedDataRequestParamSchemas = [
  requestStorageWriteSchema.requestParamsSchema,
  requestStorageReadSchema.requestParamsSchema,
  requestStorageResetSchema.requestParamsSchema,
] as const;

export const storedDataResponseParamSchemas = [
  requestStorageWriteSchema.responseParamsSchema,
  requestStorageReadSchema.responseParamsSchema,
  requestStorageResetSchema.responseParamsSchema,
] as const;

export const storedDataNotificationParamSchemas = [] as const;

export const storedDataRequestEventSchemas = [
  requestStorageWriteSchema.requestSchema,
  requestStorageReadSchema.requestSchema,
  requestStorageResetSchema.requestSchema,
] as const;

export const storedDataResponseEventSchemas = [
  requestStorageWriteSchema.responseSchema,
  requestStorageReadSchema.responseSchema,
  requestStorageResetSchema.responseSchema,
] as const;

export const storageChangeNotificationEventSchemas = [] as const;
